<template>
  <div class="promo-container">
    <!-- Header Of the page -->
    <h3 class="text-bold q-m-md inline-block">{{ headerMessage }}</h3>

    <div class="flex flex-row wrapper no-wrap q-pb-md">
      <div class="flex flex-row flex-grow">
        <q-card v-if="getLoading" class="new-tab-loading-wrapper">
          <div>
            <q-spinner color="primary" size="3em" />
          </div>
        </q-card>
        <q-card v-else class="relative-position overflow-hidden full-width">
          <q-card-section>
            <q-tabs
              v-model="eventTab"
              dense
              class="text-grey"
              active-color="primary"
              indicator-color="primary"
              align="justify"
              inline-label
              @update:model-value="(val) => onTabChange(val)"
            >
              <q-tab name="newEventTab" label="New">
                <font-awesome-icon
                  icon="fa-add"
                  size="xl"
                  color="primary"
                  class="q-ml-sm"
                />
              </q-tab>
              <q-tab name="editEventTab" label="Edit " disable>
                <font-awesome-icon
                  icon="fa-edit"
                  size="xl"
                  color="primary"
                  class="q-ml-sm"
                />
              </q-tab>
            </q-tabs>
            <q-separator />
          </q-card-section>

          <q-card-section>
            <div class="flex q-mt-lg items-start q-gutter-md no-wrap">
              <div class="flex-grow">
                <q-input
                  dense
                  outlined
                  class="q-mt-sm"
                  v-model="currentEvent.eventName"
                  label="Event Name"
                  :rules="[
                    (val) =>
                      val.length >= 3 || 'Please use Minimum 3 characters',
                  ]"
                  lazy-rules
                  :readonly="currentEvent.stats === 'closed'"
                />
                <GamesFilter
                  :value="currentEvent.gameIDs"
                  @update:value="(val) => (currentEvent.gameIDs = val)"
                  :disabled="currentEvent.stats === 'closed'"
                  :edit="updateGamesFilterKey"
                />
                <q-input
                  dense
                  outlined
                  class="q-mt-sm"
                  v-model="currentEvent.highlightText"
                  label="Highlight"
                  :readonly="currentEvent.stats === 'closed'"
                  :rules="[
                    (val) =>
                      val.length <= 120 || 'Please use Maximum 120 characters',
                  ]"
                />
                <q-input
                  dense
                  outlined
                  class="q-mt-sm"
                  v-model="currentEvent.title"
                  label="Title"
                  :readonly="currentEvent.stats === 'closed'"
                  :rules="[
                    (val) =>
                      val.length <= 120 || 'Please use Maximum 120 characters',
                  ]"
                />
                <q-input
                  dense
                  class="q-mt-sm c-textarea"
                  type="textarea"
                  outlined
                  rows="3"
                  v-model="currentEvent.subtitleHtml"
                  label="Subtitle HTML Content"
                  :readonly="currentEvent.stats === 'closed'"
                  :rules="[
                    (val) => {
                      const textOnly = val.replace(/<[^>]+>/g, '').trim();

                      return textOnly.length <= 100 || 'Please use Maximum 100 characters';
                    },
                  ]"
                />
                <q-input
                  dense
                  class="q-mt-sm c-textarea"
                  type="textarea"
                  outlined
                  rows="3"
                  v-model="currentEvent.bannerHtml"
                  label="Banner HTML Content"
                  :readonly="currentEvent.stats === 'closed'"
                  :rules="[
                    (val) => {
                      const textOnly = val.replace(/<[^>]+>/g, '').trim();

                      return textOnly.length <= 100 || 'Please use Maximum 100 characters';
                    },
                  ]"
                />
                <HtmlTip />
              </div>

              <div class="flex justify-center">
                <q-date
                  :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                  :text-color="getEnv === 'stage' ? 'black' : 'white'"
                  event-color="red"
                  v-model="selectedEventDatePicker"
                  range
                  mask="MM/DD/YYYY"
                  :options="getFreeEventDates(this.currentEvent, this.previewModeList)"
                  @update:model-value="(val) => onChangeEventDate(val)"
                />
              </div>
            </div>
          </q-card-section>
          <q-card-section class="q-p-0">
            <p>Preview</p>

            <div class="promo-content">
              <div
                class="promo-inner"
                v-if="
                  currentEvent.title ||
                  currentEvent.subtitleHtml ||
                  currentEvent.highlightText
                "
              >
                <span class="promo-highlight">
                  {{ currentEvent.highlightText }}
                </span>
                <div class="promo-title">{{ currentEvent.title }}</div>

                <div
                  class="promo-subtitle"
                  v-html="currentEvent.subtitleHtml"
                ></div>
                <span class="btn-promo">Log in</span>
                <span class="promo-link">Not registered? Create account ></span>
              </div>
            </div>

            <div class="promo-content q-mt-md" v-if="currentEvent.bannerHtml">
              <div class="promo-banner" v-html="currentEvent.bannerHtml"></div>
            </div>
          </q-card-section>
          <q-card-section>
            <div class="q-mt-lg q-mb-md flex justify-between">
              <div>
                <q-btn
                  v-if="eventTab === 'newEventTab'"
                  label="Add Event"
                  @click="createEventModal = true"
                  color="positive"
                  :disable="handlerDisableCreateEvent()"
                />
                <q-btn
                  v-else
                  label="Edit Event"
                  @click="createEventModal = true"
                  color="positive"
                  :disable="handlerDisableCreateEvent()"
                />
                <q-btn
                  v-if="getEnv === 'stage' && isProdEnv"
                  class="q-ml-md"
                  color="primary"
                  label="switch to production"
                  @click="sendToProd"
                  :disable="currentEvent.eventName.length < 3"
                >
                  <q-tooltip self="center left">
                    Send fields to Production environment</q-tooltip
                  >
                  <font-awesome-icon
                    class="q-ml-md"
                    icon="fa-share"
                    size="lg"
                    :color="
                      currentEvent.eventName.length < 3 ? 'gray' : 'white'
                    "
                  />
                </q-btn>
              </div>
              <div>
                <q-btn
                  v-if="eventTab === 'editEventTab'"
                  class="q-ml-sm"
                  label="Duplicate Promo"
                  @click="() => duplicateEvent(currentEvent)"
                  color="primary"
                />
                <q-btn
                  v-else
                  class="q-ml-sm"
                  label="reset Promo"
                  @click="
                    () => {
                      this.resetEventModal = true;
                    }
                  "
                  color="primary"
                />
                <q-btn
                  v-if="
                    eventTab === 'editEventTab' &&
                    this.currentEvent.stats !== 'closed' &&
                    this.currentEvent.stats !== ''
                  "
                  class="q-ml-sm"
                  color="negative"
                  @click="deleteEventModal = true"
                >
                  <font-awesome-icon icon="fa-trash" size="sm" color="negative"
                /></q-btn>
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
      <q-card class="flex timeline">
        <q-card-section class="timeline-card-section">
          <div class="flex no-wrap items-center justify-between">
            <q-input
              v-if="!getLoading"
              borderless
              v-model="searchText"
              input-class="text-left"
              class="q-ml-md"
              :label="'Search events'"
              @update:model-value="(val) => onSearchChange(val)"
            >
              <template v-slot:prepend>
                <font-awesome-icon
                  v-if="searchText === ''"
                  icon="fa-search"
                  size="sm"
                  color="primary"
                />
                <font-awesome-icon
                  v-else
                  icon="fa-xmark"
                  size="xl"
                  color="primary"
                  name="clear"
                  class="cursor-pointer"
                  @click="() => onSearchChange('')"
                />
              </template>
            </q-input>
            <q-btn round color="primary" v-if="!getLoading">
              <font-awesome-icon
                icon="fa-calendar-days"
                size="xl"
                color="primary"
              />
              <q-popup-proxy
                @before-show="updateProxyDateInTimeline"
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="proxyDate"
                  mask="MM/DD/YYYY"
                  color="grey-2"
                  text-color="black"
                  :options="availableEventsDates"
                >
                  <div class="row items-center justify-end q-gutter-sm">
                    <q-btn label="Cancel" color="primary" flat v-close-popup />
                    <q-btn
                      label="OK"
                      color="primary"
                      flat
                      @click="setEventSearchDate"
                      v-close-popup
                    />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-btn>
          </div>
        </q-card-section>

        <q-card-section v-if="getLoading">
          <div class="q-ma-md">
            <q-skeleton height="15px" />
            <q-skeleton height="40px" class="q-mt-md" />
          </div>
          <div class="q-ma-md">
            <q-skeleton height="15px" />
            <q-skeleton height="40px" class="q-mt-md" />
          </div>
          <div class="q-ma-md">
            <q-skeleton height="15px" />
            <q-skeleton height="40px" class="q-mt-md" />
          </div>
          <div class="q-ma-md">
            <q-skeleton height="15px" />
            <q-skeleton height="40px" class="q-mt-md" />
          </div>
        </q-card-section>

        <q-card-section v-else class="timeline-body">
         <EmptyList :listIsEmpty="!previewModeList.length" :searchTextIsEmpty="!searchText.length" />
          <q-timeline>
            <q-timeline-entry
              v-for="event in previewModeList"
              :key="event.eventKey"
              class="timeline-entry"
              @click="() => timelineEventChange(event)"
              side="left"
              :title="event.eventName"
              :subtitle="
                displayDatesInTimeline(event.eventDateStart, event.eventDateEnd)
              "
              :color="event.timeLineColor"
            >
              <template v-slot:title>
                {{ event.eventName }}
              </template>
            </q-timeline-entry>
          </q-timeline>
        </q-card-section>
      </q-card>
    </div>

    <q-dialog v-model="createEventModal">
      <q-card class="card-modal">
        <q-card-section>
          <h6 class="q-ml-sm">
            {{ !this.currentEvent.eventKey ? createModalText : editModalText }}
          </h6>
          <strong> ({{ currentEvent.eventName.toUpperCase() }}) </strong>
        </q-card-section>

        <q-card-actions class="flex justify-between q-ma-md">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn label="Confirm" color="positive" @click="createEventConfirm" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="deleteEventModal">
      <q-card class="card-modal">
        <q-card-section>
          <h6 class="q-ml-sm">{{ deleteModalText }}</h6>
          <strong class="q-ml-sm"> ({{ currentEvent.eventName.toUpperCase() }}) </strong>
        </q-card-section>

        <q-card-actions class="flex justify-between q-ma-md">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn label="Delete" color="primary" @click="deleteEventConfirm" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="resetEventModal">
      <q-card class="card-modal">
        <q-card-section>
          <h6 class="q-ml-sm">{{ resetModalText }}</h6>
          <strong class="q-ml-sm"> ({{ currentEvent.eventName.toUpperCase() }}) </strong>
        </q-card-section>

        <q-card-actions class="flex justify-between q-ma-md">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn label="Reset" color="primary" @click="() => {
            this.resetEventModal = false;
            newEvent()
          }" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import {
  convertDateIntoAmericanFormat,
  getEventByDate,
  datePickerTimelineOptionsFn,
  getFreeEventDates
} from "@/utils";
import GamesFilter from "@/components/games-filter/GamesFilter.vue";
import HtmlTip from "@/components/html-tip/HtmlTip.vue";
import EmptyList from "@/components/empty-list/EmptyList.vue";

export default {
  name: "PreviewModeView",
  components: { GamesFilter, HtmlTip, EmptyList },
  data() {
    return {
      isProdEnv: false,
      eventTab: "newEventTab",
      headerMessage: "Preview mode",

      previewModeList: [],
      gamesList: [],

      updateGamesFilterKey: false,

      currentEvent: {
        eventName: "",
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
        highlightText: "",
        title: "",
        subtitleHtml: "",
        bannerHtml: "",
        gameIDs: [],
      },

      initialDate: null,
      proxyDate: null,
      promoEventsFirstDate: "",
      promoEventsLastDate: "",
      selectedEventDatePicker: { from: "", to: "" },
      searchText: "",

      deleteEventModal: false,
      createEventModal: false,
      resetEventModal: false,
      createModalText: "Are you sure you want to Add this Event?",
      editModalText: "Are you sure you want to Edit the Event?",
      deleteModalText: "Are you sure you want to DELETE the Event?",
      resetModalText: "Are you sure you want to RESET the Event?",

      convertDateIntoAmericanFormat,
      getEventByDate,
      datePickerTimelineOptionsFn,
      getFreeEventDates
    };
  },

  async created() {
    this.isProdEnv = process.env.NODE_ENV === "production";
  },

  // Async mounted to wait for API requests
  async mounted() {
    await this.getAllPreviewModeList();
    await this.actionGetGamesFeed();

    // Check if the component came from StageToProd and fill with previous stage infos
    if (this.getPromoToProd.eventName && this.getEnv === "prod") {
      this.currentEvent = {
        eventName: this.getPromoToProd.eventName,
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
        bannerHtml: this.getPromoToProd.bannerHtml,
        subtitleHtml: this.getPromoToProd.subtitleHtml,
        title: this.getPromoToProd.title,
        highlightText: this.getPromoToProd.highlightText,
        gameIDs: this.getPromoToProd.gameIDs,
      };
      this.eventTab = "newEventTab";
      // Clear persistDate after we fill the form
      this.setPromoToProd({});
    } else {
      this.newEvent();
    }

    // clear persistDate if is Stage
    if (this.getEnv === "stage") {
      this.setPromoToProd({});
    }
  },

  computed: {
    ...mapGetters({
      getPreviewModes: "previewMode/getPreviewModes",
      getLoading: "previewMode/getLoading",
    }),
    ...mapGetters({
      getGamesList: "games/getGamesList",
    }),
    ...mapGetters({
      getEnv: "selectEnv/getEnv",
    }),
    ...mapGetters({
      getPromoToProd: "generalPersist/getPromoToProd",
    }),
    ...mapGetters({
      getIsOpenSelectImageModal: "selectImage/getIsOpenModal",
    }),
  },

  methods: {
    ...mapActions({
      actionGetPreviewModes: "previewMode/actionGetPreviewModes",
      actionSetPreviewMode: "previewMode/actionSetPreviewMode",
      actionDeletePreviewMode: "previewMode/actionDeletePreviewMode",
    }),
    ...mapActions({
      setPromoToProd: "generalPersist/setPromoToProd",
    }),
    ...mapActions({
      actionGetGamesFeed: "games/actionGetGamesFeed",
    }),
    ...mapActions({
      setEnv: "selectEnv/setEnv",
    }),

    async getAllPreviewModeList() {
      this.initialDate = new Date().toDateString();
      this.proxyDate = new Date().toDateString();
      await this.actionGetPreviewModes(this.getEnv)
        .then((response) => {
          if (response) {
            this.previewModeList = _.cloneDeep(response);
          }
          this.promoEventsFirstDate = new Date(
            this.previewModeList[this.previewModeList.length - 1].eventDateStart
          ).toDateString();
          this.promoEventsLastDate = new Date(
            this.previewModeList[0].eventDateEnd
          ).toDateString();
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },

    sendToProd() {
      this.setPromoToProd({
        eventName: this.currentEvent.eventName,
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
        bannerHtml: this.currentEvent.bannerHtml,
        subtitleHtml: this.currentEvent.subtitleHtml,
        title: this.currentEvent.title,
        highlightText: this.currentEvent.highlightText,
        gameIDs: this.currentEvent.gameIDs,
      });
      this.setEnv("prod");
    },

    newEvent() {
      this.currentEvent = {
        eventName: "",
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
        gameIDs: [],
        highlightText: "",
        title: "",
        subtitleHtml: "",
        bannerHtml: "",
      };

      this.eventTab = "newEventTab";
    },
    async editEvent() {
      this.selectedEventDatePicker = {
        from: this.convertDateIntoAmericanFormat(
          this.currentEvent.eventDateStart
        ),
        to: this.convertDateIntoAmericanFormat(this.currentEvent.eventDateEnd),
      };

      this.eventTab = "editEventTab";
    },
    duplicateEvent(promo) {
      this.currentEvent = {
        eventName: promo.eventName,
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
        highlightText: promo.highlightText,
        title: promo.title,
        subtitleHtml: promo.subtitleHtml,
        bannerHtml: promo.bannerHtml,
        gameIDs: promo.gameIDs || [],
      };
      this.eventTab = "newEventTab";
    },
    handlerDisableCreateEvent() {
      return (
        this.currentEvent.eventName.length < 3 ||
        this.currentEvent.eventDateStart === "" ||
        this.currentEvent.eventDateEnd === "" ||
        this.currentEvent.stats === "closed"
      );
    },

    onChangeEventDate(val) {
      if (!val) {
        this.currentEvent.eventDateStart = "";
        this.currentEvent.eventDateEnd = "";
      } else if (typeof val === "string") {
        this.currentEvent.eventDateStart = val;
        this.currentEvent.eventDateEnd = val;
      } else {
        this.currentEvent.eventDateStart = val.from;
        this.currentEvent.eventDateEnd = val.to;
      }
    },

    onTabChange(val) {
      if (val === "newEventTab") this.newEvent();
    },

    onSearchChange(val) {
      if (val === "") {
        this.searchText = "";
      }
      this.resetPromoEvents();
      this.previewModeList = this.previewModeList.filter((product) => {
        return product.eventName.toLowerCase().indexOf(val.toLowerCase()) != -1;
      });
    },
    resetPromoEvents() {
      this.previewModeList = _.cloneDeep(this.getPreviewModes);
    },
    // Called when user click in a new Promo from the Timeline
    timelineEventChange(promo) {
      this.currentEvent = {
        eventName: promo.eventName,
        eventDateStart: promo.eventDateStart,
        eventDateEnd: promo.eventDateEnd,
        stats: promo.stats,
        eventKey: promo.eventKey,
        bannerHtml: promo.bannerHtml,
        subtitleHtml: promo.subtitleHtml,
        title: promo.title,
        highlightText: promo.highlightText,
        gameIDs: promo.gameIDs,
      };
      this.initialDate = this.convertDateIntoAmericanFormat(
        promo.eventDateStart
      );
      this.editEvent();
    },
    setEventSearchDate() {
      const clonedEvent = _.cloneDeep(
        this.getEventByDate(this.proxyDate, this.previewModeList)
      );
      if (clonedEvent) {
        this.currentEvent = { ...clonedEvent };
        this.eventTab = "editEventTab";
        this.editEvent();
      } else {
        this.$q.notify({
          type: "warning",
          message: `There's no Promotion at: ${this.convertDateIntoAmericanFormat(
            this.proxyDate
          )}`,
        });
        this.newEvent();
      }
      this.initialDate = this.convertDateIntoAmericanFormat(this.proxyDate);
    },
    updateProxyDateInTimeline() {
      this.proxyDate = this.convertDateIntoAmericanFormat(this.initialDate);
    },
    availableEventsDates(date) {
      return this.datePickerTimelineOptionsFn(
        date,
        this.promoEventsFirstDate,
        this.promoEventsLastDate
      );
    },

    displayDatesInTimeline(dateStart, dateEnd) {
      return (
        new Date(dateStart).toLocaleDateString("en-us", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }) +
        " - " +
        new Date(dateEnd).toLocaleDateString("en-us", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );
    },

    async createEventConfirm() {
      this.createEventModal = false;
      await this.actionSetPreviewMode(this.currentEvent)
        .then(async () => {
          await this.getAllPreviewModeList();
          this.$q.notify({
            type: "positive",
            message: `The event was successfully ${
              this.currentEvent.eventKey ? "Edited" : "Created"
            }`,
          });
          this.newEvent();
        })
        .catch((err) => {
          this.$q.notify({
            type: "negative",
            message: err.response.data.details[0].Message,
          });
        });
      this.onSearchChange("");
    },
    async deleteEventConfirm() {
      this.deleteEventModal = false;
      await this.actionDeletePreviewMode(this.currentEvent.eventKey)
        .then(async () => {
          await this.getAllPreviewModeList();
          this.$q.notify({
            type: "positive",
            message: `The event was successfully Deleted`,
          });
          this.newEvent();
        })
        .catch(() => {
          this.$q.notify({
            type: "negative",
            message: `An error occurred trying to Delete`,
          });
        });
      this.onSearchChange("");
    },

    async httpCheck(val) {
      return val.startsWith("http");
    },
  },

  watch: {
    currentEvent() {
      this.selectedEventDatePicker = {
        from: this.convertDateIntoAmericanFormat(
          this.currentEvent.eventDateStart
        ),
        to: this.convertDateIntoAmericanFormat(this.currentEvent.eventDateEnd),
      };
      this.updateGamesFilterKey = !this.updateGamesFilterKey;
    },
  },
};
</script>

<style lang="scss" scoped>
.new-tab-loading-wrapper {
  min-height: 60vh;
  position: relative;

  div {
    position: absolute;
    left: 50%;
    top: 10%;
  }
}

.c-textarea ::v-deep textarea {
  resize: none;
}

.wrapper {
  gap: 37px;
}

.flex-grow {
  flex-grow: 1;
}

.timeline {
  min-width: 278px;
  min-height: 100%;
  width: 378px;
  overflow: hidden;
  overflow-y: scroll;
  position: relative;
}

.timeline-card {
  position: absolute;
  width: 100%;
  overflow: scroll;
  overflow-x: hidden;
}

.timeline-entry {
  cursor: pointer !important;
}

.timeline-card-section {
  position: sticky;
  height: 80px;
  top: 0;
  background-color: rgb(241, 241, 241);
  z-index: 2;
  width: 100%;
}

.timeline-body {
  position: absolute;
  top: 80px;
  height: calc(100% - 80px);
  width: 100%;
  overflow: scroll;
}

.card-modal {
  width: 600px;
  max-width: 80vw;
}

.row-border {
  margin-left: auto;
  margin-right: auto;
  border: 1px solid gray;
  max-width: 1140px;
  min-height: 280px;
}

.promo-content {
  font-family: "Helvetica" !important;
  overflow: hidden;
  min-height: 32px;
  font-size: 16px;
  background-color: #f9f8f6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.promo-inner {
  min-height: 195px;
  width: 100%;
  max-width: 474px;
  background-color: #71002a;
  color: #ffffff;
  text-align: center;
  padding: 16px 10px;
  margin: 16px;
}

.promo-highlight {
  display: block;
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  min-height: 14px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  margin-bottom: 24px;
}

.promo-subtitle {
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  min-height: 16px;
  margin-bottom: 24px;
}

.promo-title {
  font-size: 22.5px;
  line-height: 26px;
  font-weight: 700;
  min-height: 26px;
}

.btn-promo {
  background-color: #ffffff;
  color: #121212;
  height: 35px;
  width: 144px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 14px;
  display: inline-block;
  vertical-align: middle;
  padding: 7px;
  margin-bottom: 8px;
}

.promo-link {
  display: block;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  color: #9dd6e6;
}

.promo-banner {
  min-height: 44px;
  width: 100%;
  background-color: #71002a;
  color: #ffffff;
  text-align: center;
  padding: 14px 10px;
  margin: 16px 9px;
  font-size: 14px;
  line-height: 16px;
}

</style>
